import { render, staticRenderFns } from "./taxationTag.vue?vue&type=template&id=a6e83c22&scoped=true&"
import script from "./taxationTag.vue?vue&type=script&lang=js&"
export * from "./taxationTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e83c22",
  null
  
)

export default component.exports